<template>
  <div class="SaleCar">
    <HeaderTop />
    <div class="w">
      <div ref="activity"
           :hidden="tableDataActivity.length == 0 ? true : false"
           class="activity">
        <div class="activity-box"
             v-for="(itemActivity, index) in tableDataActivity"
             :key=index>
          <div class="activity-title">
            <h6>{{itemActivity.title}}</h6>

            <p v-html="itemActivity.content">{{itemActivity.content}}</p>
          </div>
          <div class="activity-right">
            <strong><img :src=" itemActivity.carImage == null ? 'http://www.dg-hyundai.com/UploadFile/pic/gzysc1/zanwu.gif' : url + itemActivity.carImage.imageName" /></strong>
          </div>
        </div>
      </div>
      <div class="car">
        <div class="car-brands">
          <p>品牌类型：</p>
          <ul>
            <li :class="isShow == -1 ? 'current' : ''"
                @click="changeColor(-1)">
              <router-link :to="{path:'/salecar'}">不限制</router-link>
            </li>
            <li :class="isShow == index ? 'current' : ''"
                @click="changeColor(index)"
                v-for="(item, index) in tableCarBrand"
                :key="index">
              <router-link :to="{path:'/salecar',query: {brandid: item.id}}">{{item.brandName}}</router-link>
            </li>
          </ul>
        </div>
        <!-- <div class="car-brands">
          <p >车型类别：</p>
          <ul>
            <li :class="isShow == -1 ? 'current' : ''" @click="changeColor(-1)"><router-link  :to="{path:'/salecar'}">不限制</router-link></li>
            <li :class="isShow == index ? 'current' : ''" @click="changeColor(index)" v-for="(item, index) in carModal" :key="index">
              <router-link :to="{path:'/salecar',query: {carTypeId: item.carTypeId}}">{{item.carTypeName}}</router-link>
            </li>
          </ul>
        </div> -->
        <div class="car-top">
          <span>
            <li ref="zz"
                @click="changebrandid()">默认排列</li>
          </span>
          <span>
            <li ref="fb"
                @click="fb()">发布时间<i :class="fbIndex == true ? 'icon-web-icon-' : 'icon-xiajiang'"
                 class="iconfont"></i></li>
          </span>
          <span>
            <li ref="cl"
                @click="cl()">车龄<i :class="clIndex == true ? 'icon-web-icon-' : 'icon-xiajiang'"
                 class="iconfont"></i></li>
          </span>
          <span>
            <li ref="lc"
                @click="lc()">里程<i :class="lcIndex == true ? 'icon-web-icon-' : 'icon-xiajiang'"
                 class="iconfont"></i></li>
          </span>
          <span>
            <li ref="jg"
                @click="jg()">价格<i :class="jgIndex == true ? 'icon-web-icon-' : 'icon-xiajiang'"
                 class="iconfont"></i></li>
          </span>
          <span>
            <input v-model="minPrice"
                   placeholder="(万)"
                   type="text" />-<input v-model="maxPrice"
                   placeholder="(万)"
                   type="text" /><input @click="buttonPrice(minPrice, maxPrice)"
                   type="button"
                   value="确定" />
          </span>
        </div>

        <div class="car-box loading-area">
          <div class="car-li"
               v-for="(item, index) in tableCar.list"
               :key="index">
            <div class="box">
              <router-link :to="'/salecar/subsalecar/'+item.id">
                <img :src="item.carImageList.length == 0 ? 'http://www.dg-hyundai.com/UploadFile/pic/gzysc1/zanwu.gif' : url + item.carImageList[0].imageName" />
              </router-link>
              <div class="car-text">
                <router-link :to="'/salecar/subsalecar/'+item.id">
                  <span>{{item.title}}</span>
                  <h3>￥{{item.price}}萬</h3>
                  <!-- <b>萬</b> -->
                </router-link>
              </div>
            </div>
            <div class="car-status"
                 v-if="item.status == 3"><span>已售</span></div>
          </div>
        </div>
        <div class="car-button"
             v-if="pages <= total/12"
             @click='loadMore'>
          <input type="button"
                 value="加载更多" />
        </div>
        <div class="car-button"
             v-else>
          <span>暂时没有了</span>
        </div>
      </div>
      <FooterAbout />
    </div>
    <Copy />
  </div>
</template>

<script>
import { reqCarList, reqCarBrandList, reqActivity, reqGetUsedCars, BASE_URL } from '../api/'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Copy from '../components/Copy.vue'
import Cookies from 'js-cookie'
import '../js/NumFormat.js'

export default {
  name: 'SaleCar',
  data () {
    return {
      otherBrand: this.$route.query.otherBrand || '', //其他品牌
      fbIndex: '',
      clIndex: '',
      lcIndex: '',
      jgIndex: '',
      isShow: -1,
      // loading: true,
      url: BASE_URL + '/usedcar/upload/usedCar/',
      a: 12,
      brandid: '',
      carAttr: '', //车辆类型ID
      typeCo: '',
      tableCarBrand: [], //品牌列表
      carModal: [
        { carTypeId: 0, carTypeName: '经济型车' },
        { carTypeId: 1, carTypeName: '准新车' },
        { carTypeId: 2, carTypeName: '三厢车' },
        { carTypeId: 3, carTypeName: '两厢轿车' },
        { carTypeId: 4, carTypeName: '旅行车' },
        { carTypeId: 5, carTypeName: '越野车' },
        { carTypeId: 6, carTypeName: '性能车' },
        { carTypeId: 7, carTypeName: '商务车' }
      ],
      tableCar: [], //返回的结果集合
      total: 0,
      pages: 1, //当前页
      page_count: '',
      pageSize: 12, //一页展示多少
      tableDataActivity: [],
      totalActivity: 0,
      minPrice: '',
      maxPrice: '',
      publishSort: '',
      carYearSort: '',
      mileageSort: '',
      priceSort: '',
      position: Cookies.get('position') || 2
    }
  },
  methods: {
    changeColor (index) {
      this.isShow = index
      // console.log('this.isShow,',this.isShow)
    },
    loadMore () {
      this.pages += 1

      const currentPage = this.pages
      const pageSize = this.pageSize
      // console.log('currentPage', currentPage)
      reqGetUsedCars(currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, this.position, this.otherBrand).then(res => {
        // res.data.list.sort((a,b) => {
        //   return b.id - a.id
        // })
        this.tableCar.list = this.tableCar.list.concat(res.data.list) //将请求回来的数据和上一次进行组合
        // console.log('this.tableCarthis.tableCarthis.tableCar123', this.tableCar)
      }).catch(err => {
        // console.log('err', err)
        // this.$toast.fail("系统开小差,请重试")
      })
    },
    // changBrand(id) {
    //   console.log(id)
    //   // this.brandid = 
    // },
    changebrandid () {
      // console.log('position', this.position)
      this.$refs.zz.classList.add("current")
      this.$refs.fb.classList.remove("current")
      this.$refs.cl.classList.remove("current")
      this.$refs.lc.classList.remove("current")
      this.$refs.jg.classList.remove("current")
      this.fbIndex = ''
      this.clIndex = ''
      this.lcIndex = ''
      this.jgIndex = ''
      this.minPrice = ''
      this.maxPrice = ''

      this.tableCar = []
      this.total = 0
      this.page_count = ''
      this.pages = 1
      if (this.brandid == undefined) {
        this.brandid = ''
      }

      if (this.carAttr == undefined) {
        this.carAttr = ''
      }
      const currentPage = this.pages
      const pageSize = this.pageSize
      const brandId = this.brandid
      const carAttr = this.carAttr
      const minPrice = this.minPrice
      const maxPrice = this.maxPrice
      const publishSort = this.fbIndex
      const carYearSort = this.clIndex
      const mileageSort = this.lcIndex
      const priceSort = this.jgIndex


      reqGetUsedCars(currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, this.position, this.otherBrand).then(res => {
        if (!res.data.errno) {
          res.data.list.sort((a, b) => {
            return a.status - b.status
          })
          // console.log('fbIndex', this.fbIndex)
          this.tableCar = res.data
          this.total = res.data.total
          this.page_count = res.data.nextPage
          console.log(this.tableCar)
          // console.log('this.brandidthis.brandidthis.brandid', this.brandid)
          // if (this.brandid != '') {
          // res.data.list.forEach(val =>{
          //   if(this.brandid === val.brandId){
          //     this.tableCar.push(val)
          //   }
          // })
          // if(this.typeCo == 'fb'){
          //   this.fb()
          // }
          // console.log('this.brandid', this.brandid)
          // console.log('this.brandid',  this.total)
          // } else {
          // console.log('this.brandid', this.brandid)
          // console.log('this.brandid', res.data)
          // this.tableCar = res.data.list
          // this.total =  res.data.total
          // }
          // this.page_count = res.data.navigatepageNums.length+1
          // console.log('tableCar', this.tableCar)
        }
      })
    },
    buttonPrice (minPriceA, maxPriceA) {
      this.tableCar = []
      this.total = 0
      this.page_count = ''
      this.pages = 1
      this.minPrice = minPriceA
      this.maxPrice = maxPriceA
      if (this.brandid == undefined) {
        this.brandid = ''
      }
      if (this.carAttr == undefined) {
        this.carAttr = ''
      }
      // console.log('minPriceA', minPriceA)
      // console.log('maxPriceA', maxPriceA)
      const minPrice = minPriceA
      const maxPrice = maxPriceA
      const currentPage = this.pages
      const pageSize = this.pageSize
      const brandId = this.brandid
      const carAttr = this.carAttr
      const position = this.position
      const publishSort = this.fbIndex === '' ? '' : (this.fbIndex == 1 ? '1' : '0')
      const carYearSort = this.clIndex === '' ? '' : (this.clIndex == 1 ? '1' : '0')
      const mileageSort = this.lcIndex === '' ? '' : (this.lcIndex == 1 ? '1' : '0')
      const priceSort = this.jgIndex === '' ? '' : (this.jgIndex == 1 ? '1' : '0')
      // console.log('buttonPrice--buttonPrice---buttonPrice---buttonPrice--')
      // console.log('position', position)
      // console.log('currentPage', currentPage)
      // console.log('pageSize', pageSize)
      // console.log('brandId', brandId)
      // console.log('publishSort', publishSort)
      // console.log('carYearSort', carYearSort)
      // console.log('mileageSort', mileageSort)
      // console.log('minPrice', minPrice)
      // console.log('maxPrice', maxPrice)
      reqGetUsedCars(currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, position, this.otherBrand).then(res => {
        if (!res.data.errno) {
          this.tableCar = res.data
          this.total = res.data.total
          this.page_count = res.data.nextPage
        }
      })
    },
    fb () {
      if (this.fbIndex === '') {
        this.fbIndex = 1
        this.FunYN(this.$refs.fb)
        // console.log('fbIndexA', this.fbIndex)
      } else if (this.fbIndex == 1) {
        this.fbIndex = 0
        this.FunYN(this.$refs.fb)
        // console.log('fbIndexB', this.fbIndex)
      } else {
        this.fbIndex = 1
        this.FunYN(this.$refs.fb)
        // console.log('fbIndexC', this.fbIndex)
      }
    },
    cl () {
      if (this.clIndex === '') {
        this.clIndex = 1
        this.FunYN(this.$refs.cl)
      } else if (this.clIndex == 1) {
        this.clIndex = 0
        this.FunYN(this.$refs.cl)
      } else {
        this.clIndex = 1
        this.FunYN(this.$refs.cl)
      }
    },
    lc () {
      if (this.lcIndex === '') {
        this.lcIndex = 1
        this.FunYN(this.$refs.lc)
      } else if (this.lcIndex == 1) {
        this.lcIndex = 0
        this.FunYN(this.$refs.lc)
      } else {
        this.lcIndex = 1
        this.FunYN(this.$refs.lc)
      }
    },
    jg () {
      if (this.jgIndex === '') {
        this.jgIndex = 1
        this.FunYN(this.$refs.jg)
      } else if (this.jgIndex == 1) {
        this.jgIndex = 0
        this.FunYN(this.$refs.jg)
      } else {
        this.jgIndex = 1
        this.FunYN(this.$refs.jg)
      }
    },
    FunYN (aa) {
      aa.classList.add("current")
      this.$refs.zz.classList.remove("current")
      this.tableCar = []
      this.total = 0
      this.page_count = ''
      this.pages = 1
      if (this.brandid == undefined) {
        this.brandid = ''
      }
      const currentPage = this.pages
      const pageSize = this.pageSize
      const brandId = this.brandid
      const carAttr = this.carAttr
      const minPrice = this.minPrice
      const maxPrice = this.maxPrice
      const publishSort = this.fbIndex === '' ? '' : (this.fbIndex == 1 ? '1' : '0')
      const carYearSort = this.clIndex === '' ? '' : (this.clIndex == 1 ? '1' : '0')
      const mileageSort = this.lcIndex === '' ? '' : (this.lcIndex == 1 ? '1' : '0')
      const priceSort = this.jgIndex === '' ? '' : (this.jgIndex == 1 ? '1' : '0')
      reqGetUsedCars(currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, this.position, this.otherBrand).then(res => {
        if (!res.data.errno) {
          this.tableCar = res.data
          this.total = res.data.total
          this.page_count = res.data.nextPage
        }
      })
    }
  },
  created () {
    console.log('开始')
    // console.log('this.$route.params', this.$route.params.minPriceA, 'this.$route.params', this.$route.params.maxPriceA)
    if (this.$route.params.minPriceA != undefined && this.$route.params.maxPriceA != undefined) {
      this.buttonPrice(this.$route.params.minPriceA, this.$route.params.maxPriceA)
    } else {
      // if (this.$route.query.otherBrand == 'undefined') {
      //   this.otherBrand = 0
      // }
      // this.otherBrand = this.$route.query.otherBrand
      this.carAttr = this.$route.query.carTypeId
      this.brandid = this.$route.query.brandid
    }
    // console.log('this.carAttr', this.carAttr)
    // console.log('this.otherBrand', this.otherBrand)
    // console.log('this.brandid', this.brandid)
    // console.log('this.carTypeId', this.carTypeId)
    reqCarBrandList().then(resd => {
      if (!resd.data.errno) {
        this.tableCarBrand = resd.data
        this.tableCarBrand.sort((obj1, obj2) => {
          return obj1.sortNo - obj2.sortNo
        })
        this.tableCarBrand.forEach((val, i) => {
          if (this.brandid != undefined) {
            if (this.brandid == val.id) {
              // console.log('iiiiiiiiiiiiiii', i)
              this.isShow = i
            }
          } else {
            if (this.carAttr == val.id) {
              // console.log('iiiiiiiiiiiiiii', i)
              this.isShow = i
            }
          }
        })
      }
      // console.log('this.tableCarBrand', this.tableCarBrand)
    })
    reqActivity(this.pages, this.totalActivity, this.position).then(resActivity => {
      if (!resActivity.data.errno) {
        resActivity.data.list.sort((obj1, obj2) => {
          return obj2.id - obj1.id
        })
        resActivity.data.list.forEach(val => {
          if (val.activityType === 0) {
            this.tableDataActivity.push(val)
          }
        })
        if (this.tableDataActivity.length == 0) {
          this.$refs.activity.classList.add("none")
        } else {
          // console.log('this.tableDataActivity', this.tableDataActivity)
          this.$refs.activity.classList.remove("none")
          this.totalActivity = resActivity.data.total
        }
      }
      // console.log(resActivity)
    })
  },
  watch: {
    $route (to, from) {
      // console.log('to', to)
      // console.log('from', from)
      if (this.brandid != to.query.brandid) {
        this.brandid = to.query.brandid
        // console.log('from', from)
      } else {
        this.brandid = this.$route.query.brandid
      }
    },
    brandid () {
      this.changebrandid()
    }
  },
  computed: {
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.SaleCar {
  .none {
    display: none;
  }

  .activity {
    width: 100%;
    float: left;
    padding: 20px 0;
    text-align: left;

    // background-image url(../images/activity_bg.png)
    // background-repeat replace
    .activity-box {
      width: 48%;
      height: 120px;
      display: inline-block;
      margin: 0 1%;
      border: 1px solid #ccc;
      border-radius: 2px;
      box-shadow: 2px 2px 3px #ccc;
      background-color: #fff;
      position: relative;
      box-sizing: border-box;

      .activity-title {
        float: left;
        padding: 20px 0 0 20px;
        text-align: left;

        h6 {
          font-size: 18px;
          font-weight: 600;
          color: rgb(89, 89, 89);
          padding-bottom: 10px;
        }

        p {
          width: 280px;
          font-size: 14px;
          color: rgb(127, 127, 127);
        }
      }

      .activity-right {
        position: absolute;
        right: 16px;
        bottom: 8px;

        strong {
          width: 200px;
          height: 100px;
          display: block;
          border: 1px solid #ccc;
          // border-radius 100px 100px
          box-shadow: 1px 1px 2px #ccc;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .car {
    width: 100%;
    font-size: 16px;
    color: rgb(89, 89, 89);

    &:nth-of-type(1) {
      margin-top: 12px;
    }

    .car-brands {
      font-size: 14px;
      width: 96%;
      padding: 14px 2%;
      background: #e5e5e5;
      border-bottom: 1px solid #ccc;
      float: left;

      p {
        float: left;
        color: #3c3c3c;
        margin: 6px;
      }

      ul {
        float: left;

        li {
          float: left;
          color: #7e8c8d;
          margin: 6px;
          cursor: pointer;

          &:hover {
            color: #d81240;
          }

          a {
            &:hover {
              color: red;
            }
          }
        }
      }
    }

    .car-top {
      width: 100%;
      float: left;
      background: #e5e5e5;

      span {
        font-size: 14px;
        width: 10%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #ccc;
        float: left;

        li {
          cursor: pointer;

          &.current {
            color: red;

            i {
              color: red;
              display: inline;
            }
          }
        }

        i {
          color: #595959;
          display: none;
        }

        &:last-of-type {
          width: 30%;
          text-align: center;
          float: right;
          border-right: 0px solid #ccc;
          border-left: 1px solid #ccc;
        }

        input {
          font-size: 12px;
          width: 40px;
          height: 24px;
          border: 1px solid #ccc;
          border-radius: 1px;
          display: inline-block;
          margin: 0 3px;
          padding-left: 23px;
          position: relative;

          &[type='text'] {
            background-image: url('../images/icon-qian.png');
            background-repeat: no-repeat;
            background-size: cover;
            background-size: 14px 14px;
            background-position: 5px 5px;
          }

          &[type='button'] {
            font-size: 14px;
            width: 50px;
            height: 28px;
            border-radius: 1px;
            margin-left: 8px;
            padding: 0;
            background: #999;
            cursor: pointer;

            &:hover {
              color: #fff;
              background: #595959;
            }
          }
        }
      }
    }
  }

  .car-box {
    float: left;
    margin-top: 14px;
    padding-bottom: 6px;
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .car-li {
      background: #fff;
      margin-right: 1%;
      margin-bottom: 14px;
      transition: 0.5s all;
      -webkit-transition: 0.5s all;
      -moz-transition: 0.5s all;
      -o-transition: 0.5s all;
      -ms-transition: 0.5s all;
      flex: 0 0 24.25%;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;

      &:nth-child(4n) {
        margin-right: 0;
      }

      &:nth-of-type(4) {
        padding-right: 0;
      }

      .car-status {
        height: 40%;
        color: #fff;
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        bottom: 0;
        right: 0;
        transform: skewX(-48deg);
        background: #e40a0a;
        letter-spacing: 1px;
        box-shadow: 8px 0 6px #ccc;
        cursor: pointer;

        span {
          transform: skewX(48deg);
          font-size: 18px;
          margin-top: 50%;
        }
      }

      .box {
        width: 100%;
        border: 1px #eee solid;
      }

      &:hover {
        -webkit-box-shadow: 0 0 10px rgba(153, 153, 153, 0.5);
        -moz-box-shadow: 0 0 10px rgba(153, 153, 153, 0.5);
        box-shadow: 0 0 10px rgba(153, 153, 153, 0.5);
        position: relative;
        z-index: 9999;
        font-weight: normal;
      }

      a {
        display: block;
        padding: 2px;

        img {
          width: 100%;
        }
      }

      .car-text {
        width: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;
        margin-top: 2px;
        border-top: 1px solid #eee;

        a {
          overflow: hidden;
          padding: 10px;

          & span:hover, & span:focus {
            color: #f75555;
            text-decoration: none;
          }

          span, h3 {
            font-weight: 600;
          }

          span {
            font-size: 14px;
            color: #222;
            width: 100%;
            display: inline-block;
            transition: 0.5s all;
            -webkit-transition: 0.5s all;
            -moz-transition: 0.5s all;
            -o-transition: 0.5s all;
            -ms-transition: 0.5s all;
          }

          h3, b {
            float: left;
            line-height: 1.7;
          }

          h3 {
            font-size: 16px;
            color: #d81240;
            margin-bottom: 18px;
          }

          b {
            font-size: 12px;
            margin-top: 4px;
            margin-left: 4px;
            color: #807b7b;
          }
        }
      }
    }
  }

  .car-button {
    width: 100%;
    text-align: center;
    margin: 20px 0;
    float: left;

    input {
      font-size: 14px;
      width: 200px;
      height: 36px;
      color: #fff;
      background: #000;
      border: 1px solid #ccc;
      border-radius: 2px;
      box-shadow: 2px 2px 2px #ccc;
      cursor: pointer;
    }
  }
}

// activity 现购福利  购车即送
@media screen and (min-width: 900px) and (max-width: 1090px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      padding: 20px 0 0 15px;

      h6 {
        font-size: 16px;
      }

      p {
        width: 240px;
        font-size: 14px;
      }
    }

    .activity-right {
      strong {
        width: 180px;
      }
    }
  }
}

@media screen and (min-width: 850px) and (max-width: 940px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      padding: 20px 0 0 15px;

      h6 {
        font-size: 16px;
      }

      p {
        width: 240px;
        font-size: 14px;
      }
    }

    .activity-right {
      right: 8px;
      bottom: 16px;

      strong {
        width: 140px;
        height: 80px;
      }
    }
  }
}

@media screen and (min-width: 700px) and (max-width: 849px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      padding: 20px 0 0 15px;

      h6 {
        font-size: 14px;
      }

      p {
        width: 200px;
        font-size: 12px;
      }
    }

    .activity-right {
      right: 8px;
      bottom: 16px;

      strong {
        width: 140px;
        height: 80px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 799px) {
  .SaleCar .activity .activity-box {
    height: 100px;
  }

  .SaleCar .activity .activity-box .activity-title {
    padding: 6px 0 0 6px;

    h6 {
      // font-size 16px
    }

    p {
      // width 200px
      // font-size 12px
    }
  }

  .SaleCar .activity .activity-box .activity-right {
    right: 8px;
    bottom: 8px;

    strong {
      width: 120px;
      height: 80px;
      border: 1px solid #ccc;
      box-shadow: 0 0 1px #ccc;
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 544px) {
  .SaleCar .activity .activity-box {
    height: 100px;
  }

  .SaleCar .activity .activity-box .activity-title {
    padding: 18px 0 0 14px;

    h6 {
      width: 132px;
      font-size: 18px;
      padding-bottom: 6px;
    }

    p {
      width: 132px;
      font-size: 16px;
    }
  }

  .SaleCar .activity .activity-box .activity-right {
    right: 14px;
    bottom: 10px;
  }
}

@media screen and (min-width: 100px) and (max-width: 699px) {
  .SaleCar .activity {
    padding: 6px 0;
    text-align: center;
  }

  .SaleCar .activity .activity-box {
    width: 90%;
    display: inline-block;
    margin: 6px 0;
  }

  .SaleCar .activity .activity-box {
    .activity-title {
      padding: 10px 10px;

      h6 {
        width: 360px;
        font-size: 16px;
      }

      p {
        width: 360px;
        font-size: 14px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 558px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      h6 {
        width: 260px;
      }

      p {
        width: 260px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 480px) {
  .SaleCar .activity .activity-box {
    width: 96%;
  }
}

@media screen and (min-width: 100px) and (max-width: 440px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      overflow: auto;
      height: 70px;

      h6 {
        width: 220px;
      }

      p {
        width: 220px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 400px) {
  .SaleCar .activity .activity-box {
    .activity-title {
      h6 {
        width: 180px;
      }

      p {
        width: 180px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 1199px) {
  .SaleCar {
    .car-box {
      padding: 0 10px;
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 900px) {
  .SaleCar {
    .car {
      .car-box {
        .car-li {
          .car-status {
            height: 35%;
            right: -10px;
            transform: skew(-48deg);
            padding: 0 10px;

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 740px) {
  .SaleCar {
    .car {
      .car-box {
        padding: 0 5px;

        .car-li {
          flex: 0 0 32.333%;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }

      .car-top {
        display: none;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 540px) {
  .SaleCar .car .car-box .car-li {
    flex: 0 0 49%;

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/SaleCar.vue